import { Link } from "react-router-dom";
import { Dumbbell, Heart } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-card">
      <div className="container py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 text-foreground mb-4">
              <Dumbbell className="h-6 w-6 text-amber-500" />
              <span className="font-bold text-xl">Bodyz Gym</span>
            </Link>
            <p className="text-muted-foreground text-sm max-w-sm">
              AI-powered fitness training plans and comprehensive exercise library. 
              Built by Jacaobtech Labs to help you achieve your fitness goals.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/exercises" className="text-muted-foreground hover:text-amber-500 transition-colors">
                  Exercise Library
                </Link>
              </li>
              <li>
                <Link to="/auth/sign-up" className="text-muted-foreground hover:text-amber-500 transition-colors">
                  Get Started
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-muted-foreground hover:text-amber-500 transition-colors">
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy-policy" className="text-muted-foreground hover:text-amber-500 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-muted-foreground hover:text-amber-500 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-muted-foreground hover:text-amber-500 transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/medical-disclaimer" className="text-muted-foreground hover:text-amber-500 transition-colors">
                  Medical Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} Bodyz Gym by Jacaobtech Labs. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground flex items-center gap-1">
            Made with <Heart className="h-4 w-4 text-red-500 fill-red-500" /> for fitness enthusiasts
          </p>
        </div>
      </div>
    </footer>
  );
}
